// @flow
import Axios from 'axios';

const serverUrl = process.env.REACT_APP_SERVER_URL || '';
const config = {
  auth: {
    username: process.env.REACT_APP_SURA_API_USERNAME,
    password: process.env.REACT_APP_SURA_API_PASSWORD
  }
};

const axios = Axios.create({
  baseURL: serverUrl
});

const setAccessToken = (accessToken: string) => {
  localStorage.setItem('access_token', accessToken);
};

const clearAccessToken = () => {
  localStorage.removeItem('access_token');
};

const parseJwt = (token) => {
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(atob(base64).split('').map((c) => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
  }).join(''));

  return JSON.parse(jsonPayload);
};

const tokenIsExpired = (token) => {
  const tokenInfo = parseJwt(token);
  return new Date() / 1000 > tokenInfo.exp;
};

const isAlreadyLogged = () => {
  const token = localStorage.getItem('access_token');
  return token && parseJwt(token).clientMail && !tokenIsExpired(token);
}

const clientMailFromToken = () => {
  const token = localStorage.getItem('access_token');
  if (isAlreadyLogged()) return parseJwt(token).clientMail;
  else return null;
}

axios.interceptors.request.use(async (req) => {
  const token = localStorage.getItem('access_token');
  if(req.url !== `${serverUrl}/api/general/token`) {
    if (token && !tokenIsExpired(token)) {
      req.headers.Authorization = `Bearer ${token}`;
    } else {
      const res = await axios.post(`${serverUrl}/api/general/token`, {}, config);
      if(res.data && res.data.success)
      { 
        setAccessToken(res.data.token);
        req.headers.Authorization = `Bearer ${res.data.token}`;
      }
    }
  }
  return req;
});

axios.interceptors.response.use((res) => {
  return res;
}, (error) => {
  if (error.response.status === 401) {
    // Si el Token es invalido, lo borramos.
    setAccessToken('');
  }
});

export default axios;
export {
  setAccessToken,
  clearAccessToken,
  isAlreadyLogged,
  clientMailFromToken
};
